import { createElement } from 'react';

import mapCustomAttributeToInput from 'hb-react/shared/components/formik/utils/mapCustomAttributeToInput';

import { type CustomAttributeProps } from './types';

export const CustomAttribute = ({
  componentRef,
  customAttribute,
  name,
  info,
  iconInfo,
  ...otherProps
}: CustomAttributeProps) => {
  const { component, props } = mapCustomAttributeToInput({
    ...customAttribute,
    info,
    iconInfo,
  });

  return createElement(component, {
    componentRef,
    name,
    ...otherProps,
    ...props,
  });
};

export default CustomAttribute;
